/**
 * Quien esta usando la pantalla.
 *
 * ===========================================================================
 * YA NO SE ELIGE: SE ENTRA
 *
 * Hasta la migracion 0020 este archivo guardaba en localStorage el agente que
 * alguien habia elegido de un desplegable, y ese id viajaba en el cuerpo de
 * cada peticion. Eso no era autenticacion y nunca pretendio serlo: cualquiera
 * podia mandar cualquier id.
 *
 * Ahora la identidad sale de una cookie de sesion que emite el servidor, y esta
 * pantalla NO PUEDE LEERLA: es `HttpOnly` a proposito, para que un XSS no se
 * lleve la sesion de nadie [services/api/src/sesion.ts]. Lo unico que se sabe
 * aqui es lo que conteste `GET /sesion`, y solo mientras dure la pagina. Nada
 * de esto se guarda en localStorage: un nombre cacheado sobreviviria al cierre
 * de sesion y pintaria a alguien que ya no esta dentro.
 *
 * ===========================================================================
 * PUNTO DE INTEGRACION: ENTRA ID
 *
 * Esta es la via PROPIA, no la unica prevista. La corporativa de AGUNSA entra
 * cuando exista su App Registration, y el diseño esta hecho para no estorbarla:
 *
 *   - `usuario.hash_contrasena` es NULLABLE. Significa "no entra por la via
 *     propia", nunca "cualquier contrasena sirve" [migracion 0020].
 *   - La tabla `sesion` no sabe de donde salio la identidad, asi que un login
 *     por Entra ID produce filas en la misma tabla y todo lo de aqui sigue
 *     valiendo sin cambios.
 *   - La cookie es `SameSite=Lax` y no `Strict` justo por esto: la vuelta
 *     desde login.microsoftonline.com es un GET de primer nivel, y con `Strict`
 *     llegaria sin cookie.
 *
 * Cuando llegue, en esta pantalla se añade un boton "entrar con la cuenta de la
 * empresa" al lado del formulario. Lo de aqui no cambia.
 *
 * ===========================================================================
 * LO QUE SIGUE SIN DUEÑO
 *
 * QUIEN PUEDE ABRIR QUE COTIZACION. Autenticar dice quien eres, no a que
 * cotizaciones llegas [CLAUDE.md, Visibilidad]. Sigue siendo una regla de la
 * capa de aplicacion que hoy no esta implementada, y la sesion no la resuelve.
 * ===========================================================================
 */

import { ErrorApi, leerSesion, type Sesion } from './api';

/**
 * La sesion abierta, o `null` si no hay.
 *
 * Un 401 no es un error que haya que pintar: es la respuesta esperada de quien
 * todavia no ha entrado. Cualquier otro fallo SI se propaga --si la API esta
 * caida, decirlo es mejor que pintar un login que no va a funcionar--.
 */
export async function recuperarSesion(): Promise<Sesion | null> {
  try {
    return await leerSesion();
  } catch (error) {
    if (error instanceof ErrorApi && error.codigo === 'NO_AUTENTICADO') return null;
    throw error;
  }
}
